import { render } from "./UCCEAssistant.vue?vue&type=template&id=447d9c26&scoped=true"
import script from "./UCCEAssistant.vue?vue&type=script&lang=js"
export * from "./UCCEAssistant.vue?vue&type=script&lang=js"

import "./UCCEAssistant.vue?vue&type=style&index=0&id=447d9c26&scoped=true&lang=css"
import "./UCCEAssistant.vue?vue&type=style&index=1&id=447d9c26&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-447d9c26"]])

export default __exports__